module.exports = __webpack_public_path__ + "static/img/KVX.739981d.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KVX.png
// module id = mQun
// module chunks = 1